import { Box, Chip as MuiChip, ChipProps } from '@mui/material';
import XIcon from '../../assets/icons/XIcon';
import { ChipErrorBadgeSx, ChipSx } from './ChipProps';

type Props = ChipProps & {
  active?: boolean;
  large?: boolean;
  elevated?: boolean;
  error?: boolean;
};

const Chip = (props: Props) => {
  const { sx, active, className, large, label, error, ...rest } = props;

  const chipLabel = error ? (
    <>
      {label}
      <Box component="span" sx={ChipErrorBadgeSx} />
    </>
  ) : (
    label
  );

  return (
    <MuiChip
      deleteIcon={<XIcon data-testid="x-icon" />}
      sx={{ ...ChipSx(props.elevated), ...sx }}
      className={`${active ? 'active' : ''} ${large ? 'large' : ''} ${className}`}
      label={chipLabel}
      {...rest}
    />
  );
};

export default Chip;
